<template>
  <div class="publish_recommendation">
    <MobileNav :page_title="nav_title" :isFilterRequired="false"></MobileNav>
    <el-row v-loading="is_sock_data_loading" class="publish_recommendation_container">
      <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">&nbsp;</el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <div class="publish-reco-details">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card class="search_stock_card">
                <h4>Publish Strategy</h4>
                <search-stock class="search-stock-component"></search-stock>

                <div class="input-label top-margin-10">
                  Note: Publish Strategy available - BankNifty, Finifty, Nifty50, Reliance Industries, HDFC Bank, State
                  Bank Of India, ITC , Bajaj Finance, Oil & Natural Gas Corporation, Axis Bank, ICICI Bank, Infosys,
                  Tata Motors
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card class="search_stock_card">
                <div id="video-section">
                  <div class="single-video">
                    <iframe width="100%" src="https://www.youtube-nocookie.com/embed/NYn82Xv20t4"
                      title="YouTube video player" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
                  </div>
                  <div>
                    <h3 class="primary-theme-head">
                      How to publish option strategy?
                    </h3>
                    <p class="input-label">
                      See the video to know how Future & Options works. Detailed
                      video explains everything.
                    </p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="stockList.length">
              <el-card class="chart-tabel">
                <div class="flex-space-between flex-wrap">
                  <div class="stock_detail_sec">
                    <div class="special-sec">
                      <label class="input-label">Name</label>
                      <h4>
                        {{ selectedStock.title }}
                        {{ moment(selectedStock.expiry).format("DD MMM YYYY") }}
                      </h4>
                      <div class="flex top-margin-15 flex-wrap ">
                        <div class="">
                          <el-radio v-model="order_type" label="MARKET" :disabled="isMarketClose ||
                            (editStrategyData.isEdit &&
                              editStrategyData.strategy.status !=
                              'YET_TO_LIVE')
                            " @change="setMarketPrice()">Market</el-radio>
                          <el-radio v-model="order_type" label="LIMIT" :disabled="editStrategyData.isEdit &&
                            editStrategyData.strategy.status !=
                            'YET_TO_LIVE'
                            " @change="setMarketPrice()">Limit</el-radio>
                        </div>
                        <div class="flex-space-between retail-tabs">
                          <div class="logic-buttons" @click="
                            !editStrategyData.isEdit
                              ? (selectedLogicBtn = 'BULLISH')
                              : ''
                            " :style="[
                              selectedLogicBtn == 'BULLISH'
                                ? {
                                  'background-color': '#079e3e',
                                  color: '#ffff',
                                }
                                : {},
                            ]">
                            Bullish
                          </div>
                          <div class="logic-buttons" @click="
                            !editStrategyData.isEdit
                              ? (selectedLogicBtn = 'BEARISH')
                              : ''
                            " :style="[
                              selectedLogicBtn == 'BEARISH'
                                ? {
                                  'background-color': 'red',
                                  color: '#ffff',
                                }
                                : {},
                            ]">
                            Bearish
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="flex">
                    <div class="roi-card" v-if="strategyOverviewData.status" style="color: #5ce036;">
                      <p>Target Potential</p>
                      <p>{{ average_target_potential.toFixed(2) }}</p>
                    </div>
                    <div class="roi-card" v-if="total_margin > 1">
                      <p>Capital Required</p>
                      <p>₹ {{ total_margin.toFixed(2) }}</p>
                    </div>
                  </div>
                </div>

                <hr style="border-top: 1px solid #d6d6d6" />

                <div class="options-table">
                  <div class="desktop-view">
                    <table>
                      <tr>
                        <th></th>
                        <th>Strike Price</th>
                        <!-- <th>Option</th> -->
                        <th>B/S</th>
                        <th>Lot</th>
                        <th>
                          Entry <br />
                          Premium
                        </th>
                        <th>LTP</th>
                        <th>
                          Target <br />
                          Premium
                        </th>
                        <th>Target <br />Potential</th>
                        <th>Stop Loss</th>
                        <th>Target Period</th>
                        <th>Capital Required</th>
                      </tr>
                      <tr v-for="(data, data_index) in stockList" :key="data_index">
                        <td>
                          <div v-if="!editStrategyData.isEdit">
                            <i class="el-icon-remove" style="font-size: 18px; cursor: pointer"
                              v-if="stockList.length > 1" @click="addRemoveStock('remove', data_index)"></i>
                          </div>
                          <div v-else>
                            <i class="el-icon-remove" style="font-size: 18px; cursor: pointer" v-if="
                              stockList.length > 1 &&
                              data.status == 'YET_TO_LIVE'
                            " @click="
                              addRemoveStock('remove', data_index, data.id)
                              "></i>

                            <i v-else class="el-icon-remove" style="font-size: 18px;    color: #d9d9d9;
    cursor: not-allowed;"></i>
                          </div>
                        </td>
                        <td>
                          <el-select v-model="data.strike" size="mini" collapse-tags filterable
                            placeholder="Strike Price" style="width: 100px" class="SelectDropdown"
                            :loading="strikeLoading" @change="
                              selectOption(data_index, data.strike, data),
                              calculateMargin(data, data_index),
                              setEntryPremium(data.strike, data_index)
                              " :disabled="editStrategyData.isEdit">
                            <el-option v-for="strike_data in strikeData" :key="strike_data.label"
                              :label="strike_data.label" :value="strike_data.id" :disabled="checkStrikePriceIfPresent(strike_data.id)
                                ">
                              {{ strike_data.label }}
                            </el-option>
                          </el-select>
                        </td>

                        <td>
                          <el-select v-model="data.direction" size="mini" collapse-tags filterable style="width: 70px"
                            :class="data.direction == 'SELL'
                              ? 'sellDropdown'
                              : 'buyDropdown'
                              " @change="
                                data.direction == 'SELL'
                                  ? (data.targetPremium = data.entryPremium - 1)
                                  : (data.targetPremium = data.entryPremium + 2),
                                calculateMargin(data, data_index),
                                selectOption(data_index, data.strike, data)
                                " :disabled="editStrategyData.isEdit">
                            <el-option v-for="item in directionList" :key="item.label" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </td>
                        <td>
                          <div class="lotInput flex-center target-premium">
                            <div class="lotsize-box">
                              {{ data.lotSize }}
                            </div>
                            <el-input-number v-model="data.lotQuantity" controls-position="right" size="mini" :min="0"
                              style="width: 50px" @change="calculateMargin(data, data_index)"
                              :disabled="editStrategyData.isEdit"></el-input-number>
                          </div>
                        </td>
                        <td>
                          <div class="circular-input target-premium">
                            <el-input-number v-model="data.entryPremium" controls-position="right" size="mini" :min="0"
                              style="width: 80px" @change="calculateMargin(data, data_index)" :disabled="order_type == 'MARKET' ||
                                (editStrategyData.isEdit &&
                                  editStrategyData.strategy.status == 'LIVE')
                                "></el-input-number>
                          </div>
                        </td>
                        <td>
                          <div style="
                              border: 1px solid #d6d7d9;
                              border-radius: 24px;
                              padding: 7px;
                              min-width: 55px;
                              background-color: #f5f7fa;
                            ">
                            <div>{{ data.ltp }}</div>
                            <!-- <span>{{ data.timeStamp | close_reco_time_filter }}</span> -->
                          </div>
                        </td>
                        <td>
                          <div class="circular-input target-premium">
                            <!-- :min="1"
                              :max="100" -->
                            <el-input-number v-model="data.targetPremium" controls-position="right" size="mini" :min="0"
                              style="width: 80px" @change="calculateMargin(data, data_index)"></el-input-number>
                          </div>
                        </td>
                        <td>
                          <div class="circular-input">
                            <div style="
        border: 1px solid #d6d7d9;
        border-radius: 13px;
        padding: 7px;
        width: 65px;
        background-color: #f5f7fa;
        color: #5ce036;
        margin: 0 auto;
      ">
                              <template>
                                {{
                                  data.potential
                                    ? Math.abs(data.potential.toFixed(2)) + "%"
                                    : 0
                                }}
                              </template>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="circular-input target-premium">
                            <el-input-number placeholder="Stop Loss" v-model="data.stopLoss" controls-position="right"
                              size="mini" style="width: 80px" :min="0" @change="
                                calculateMargin(data, data_index),
                                selectOption(data_index, data.strike, data)
                                "></el-input-number>
                          </div>
                        </td>
                        <td>
                          <div class="datePicker">
                            <el-date-picker v-model="data.targetPeriod" size="mini" type="date"
                              placeholder="Select Date" :picker-options="pickerOptions" style="width: 130px"
                              format="dd MMM yyyy" value-format="yyyy-MM-dd" @change="
                                selectOption(data_index, data.strike, data)
                                " :disabled="editStrategyData.isEdit">
                            </el-date-picker>
                          </div>
                        </td>
                        <td>
                          <div class="circular-input">
                            <div style="
                                border: 1px solid #d6d7d9;
                                border-radius: 13px;
                                padding: 7px;
                                min-width: 80px;
                                background-color: #f5f7fa;
                              ">
                              {{ data.margin ? data.margin.toFixed(2) : 0 }}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="mobile-view">
                    <table>
                      <tr>
                        <th></th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <i class="el-icon-remove" style="font-size: 18px; cursor: pointer" v-if="stockList.length > 1"
                            @click="
                              editStrategyData.isEdit
                                ? addRemoveStock('remove', data_index, data.id)
                                : addRemoveStock('remove', data_index)
                              "></i>
                        </td>
                      </tr>
                      <tr>
                        <th>Strike Price</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <el-select v-model="data.strike" size="mini" collapse-tags filterable
                            placeholder="Strike Price" style="width: 100px" class="SelectDropdown" @change="
                              selectOption(data_index, data.strike, data),
                              calculateMargin(data, data_index),
                              setEntryPremium(data.strike, data_index)
                              " :disabled="editStrategyData.isEdit">
                            <el-option v-for="strike_data in strikeData" :key="strike_data.label"
                              :label="strike_data.label" :value="strike_data.id" :disabled="checkStrikePriceIfPresent(strike_data.id)
                                ">
                              {{ strike_data.label }}
                            </el-option>
                          </el-select>
                        </td>
                      </tr>

                      <tr>
                        <th>B/S</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <el-select v-model="data.direction" size="mini" collapse-tags filterable style="width: 100px"
                            :class="data.direction == 'SELL'
                              ? 'sellDropdown'
                              : 'buyDropdown'
                              " @change="
                                calculateMargin(data, data_index),
                                selectOption(data_index, data.strike, data),
                                data.direction == 'SELL'
                                  ? (data.targetPremium = data.entryPremium - 1)
                                  : (data.targetPremium = data.entryPremium + 2)
                                " :disabled="editStrategyData.isEdit">
                            <el-option v-for="item in directionList" :key="item.label" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </td>
                      </tr>

                      <tr>
                        <th>Lot</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <div class="lotInput flex-center target-premium">
                            <div class="lotsize-box" style="width: 35px">
                              {{ data.lotSize }}
                            </div>
                            <el-input-number v-model="data.lotQuantity" controls-position="right" size="mini" :min="0"
                              style="width: 50px" @change="calculateMargin(data, data_index)"
                              :disabled="editStrategyData.isEdit"></el-input-number>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Entry Premium</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <div class="circular-input target-premium">
                            <el-input-number v-model="data.entryPremium" controls-position="right" size="mini" :min="0"
                              style="width: 100px" @change="calculateMargin(data, data_index)" :disabled="order_type == 'MARKET' ||
                                (editStrategyData.isEdit &&
                                  editStrategyData.strategy.status == 'LIVE')
                                "></el-input-number>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Target Premium</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <div class="circular-input target-premium">
                            <el-input-number v-model="data.targetPremium" controls-position="right" size="mini" :min="0"
                              style="width: 100px" @change="calculateMargin(data, data_index)"></el-input-number>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Stop Loss</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <div class="circular-input target-premium">
                            <el-input-number placeholder="Stop Loss" v-model="data.stopLoss" controls-position="right"
                              size="mini" style="width: 100px" :min="0" @change="
                                calculateMargin(data, data_index),
                                selectOption(data_index, data.strike, data)
                                "></el-input-number>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Capital Required</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <div class="circular-input">
                            <div style="
                                border: 1px solid #d6d7d9;
                                border-radius: 13px;
                                padding: 7px;
                                width: 90px;
                                background-color: #f5f7fa;
                                margin: 0 auto;
                              ">
                              <div>
                                {{ data.margin ? data.margin.toFixed(2) : 0 }}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Target Period</th>
                        <td v-for="(data, data_index) in stockList" :key="data_index">
                          <div class="datePicker">
                            <el-date-picker v-model="data.targetPeriod" size="mini" type="date" placeholder="Pick a day"
                              :picker-options="pickerOptions" style="width: 130px" @change="
                                selectOption(data_index, data.strike, data)
                                " :disabled="editStrategyData.isEdit">
                            </el-date-picker>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="flex-end">
                  <el-button v-if="!editStrategyData.isEdit" class="btn-light-blue-borderd" size="mini"
                    style="width: 70px; margin-top: 4px" @click="addRemoveStock('add')">
                    Add
                  </el-button>

                  <!-- <div class="reset-link">Reset prices</div>
                  <div class="reset-link">Clear all trades</div> -->
                </div>
              </el-card>
              <div class="flex-end" style="width: 100%;">
                <el-button class="btn-theme-borderd" size="mini" v-if="
                  stockList.length >= 1 &&
                  !strategyOverviewData.status &&
                  !editStrategyData.isEdit
                " style="width: 100px; margin-top: 4px" @click="checkInputFieldsStatus()">Continue</el-button>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <div class="strategy-graph-section" :style="[
              strategyOverviewData.status
                ? {
                  backgroundColor: '#ffff',
                  paddingBottom: '7px',
                  borderRadius: '10px',
                  marginTop: '10px',
                  boxShadow: '0 2px 12px 0 rgb(0 0 0 / 10%)',
                }
                : {
                  backgroundColor: 'transparent',
                },
            ]">
              <div class="graph-label-main-section" v-if="strategyOverviewData.status">
                <div>&nbsp;</div>
                <div class="graph-head">
                  Pay-off Graph
                </div>
                <div class="text-right info-label">
                  <div class="flex pl-tags">
                    Profit
                    <div class="graph-desc graph-desc-color-green"></div>
                  </div>
                  <div class="flex pl-tags">
                    Loss
                    <div class="graph-desc graph-desc-color-red"></div>
                  </div>
                </div>
              </div>
              <div ref="strategy_graph" style="width: 95%; height: 275px; margin: auto;"></div>

              <div class="flex-center" style="font-size: 12px;
                      color: #292929;
                      margin-top: -5px;
                      font-family: sans-serif;">
                <div v-if="strategyOverviewData.status">
                  Price
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="strategyOverviewData.status">
            <el-card class="chart-tabel">
              <div class="stock_detail_sec">
                <div class="special-sec">
                  <label class="input-label">Strategy Overview </label>
                </div>
              </div>
              <div class="details-chart">
                <div class="flex-space-between">
                  <div class="input-label">Max Upside</div>
                  <div class="input-label details-number" style="color:#27933b">
                    ₹ {{ strategyOverviewData.max_profit.toFixed(2) }}
                  </div>
                </div>
                <div class="flex-space-between">
                  <div class="input-label">Max Downside</div>
                  <div class="input-label details-number" style="color:#e74343">
                    ₹ {{ Math.abs(strategyOverviewData.max_loss.toFixed(2)) }}
                  </div>
                </div>
                <div class="flex-space-between">
                  <div class="input-label">Max RR Ratio</div>
                  <div class="input-label details-number">
                    {{
                      strategyOverviewData.rr_ratioA.toFixed(1) +
                      " : " +
                      strategyOverviewData.rr_ratioB
                    }}
                  </div>
                </div>
                <div class="flex-space-between">
                  <div class="input-label">Estimated Capital Required</div>
                  <div class="input-label details-number">
                    ₹
                    {{
                      strategyOverviewData.total_margin
                        ? strategyOverviewData.total_margin
                        : total_margin
                    }}
                  </div>
                </div>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row style="" v-if="stockList.length && strategyOverviewData.status">
      <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">&nbsp;</el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <div class="corner-btn">
          <el-button class="btn-theme-borderd" size="mini" style="width: 100px; margin-top: 4px; margin-bottom: 30px;"
            @click="publishReco()" :disabled="editStrategyData.isEdit && !editStrategyData.isFieldsUpdate
              ">Continue</el-button>
        </div>
      </el-col>
    </el-row>

    <el-dialog class="logic-dialog" :visible.sync="logicDialogVisible" :close-on-click-modal="false" center>
      <div class="">
        <h3>
          Logic
        </h3>
        <textarea v-model="logicDescription" name="" id="" rows="10" style="resize: none"></textarea>

        <div class="flex flex-wrap bottom-margin-0">
          <h3>
            Tags<span style="color: #878787; font-size: 10px; font-weight: 500">(Min 3)</span>
            <span style="color: red">*</span>
          </h3>

          <el-select v-model="selectedTags" multiple placeholder="Select tags" style="width: 100%">
            <el-option v-for="(item, index) in logicTagList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
          &nbsp; &nbsp; &nbsp;
        </div>

        <div class="flex flex-wrap bottom-margin-10 risk-tag">
          <h3>
            Risk Tag
            <span style="color: red">*</span>
          </h3>

          <el-select v-model="selectedRiskTags" placeholder="Select tags" style="width: 100%">
            <el-option v-for="option in risk_tag_options" :key="option.value" :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
          &nbsp; &nbsp; &nbsp;
        </div>
      </div>
      <div class="upload-profile flex">
        <i class="el-icon-picture"></i>
        <label for="upload-btn" :class="logicFiles.length >= 4 ? 'cursor-disabled' : 'cursor-pointer'">Upload
          Document</label>
        <input type="file" id="upload-btn" ref="logic_file" accept="image/*, application/pdf," multiple="multiple"
          hidden @change="getLogicAttachments()" :disabled="logicFiles.length >= 4" />
        &nbsp; &nbsp; &nbsp;
      </div>
      <div class="input-label flex" v-for="(img, img_index) in logicFiles" :key="img_index">
        <span class="ellipsis" style="margin: 5px 0; width: 250px">{{
          img.name
        }}</span>
        <i class="el-icon-delete left-margin-20 cursor-pointer" style="font-size: 15px; color: red"
          @click="removeFile(img_index)"></i>
      </div>
      <div class="flex-end flex-wrap">
        <div>
          <el-button class="btn-theme-gray-borderd" size="mini" style="width: 100px; margin-top: 10px"
            @click="logicDialogVisible = false">
            Cancel
          </el-button>
          <el-button class="btn-theme-borderd" size="mini" style="width: 100px; margin-top: 10px"
            @click="sendDataToPublish()">
            Confirm
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="published-notification-dialog" :visible.sync="published_notification_dialog_visibility"
      :lock-scroll="true" :show-close="false" :close-on-click-modal="false">
      <!-- :before-close="removePlanDialog" -->
      <div class="text-center">
        <img class="publish-icon" src="../assets/images/publishedIcon.svg" />

        <h3 class="top-margin-5 font-weight-600" style="word-break: break-word">
          Your strategy is successfully
          {{ editStrategyData.isEdit ? "edited" : "published" }}
        </h3>
        <el-button class="btn-theme-borderd left-margin-10 right-margin-10 top-margin-10" size="mini"
          @click="clearDataForSearchInput()" style="width:190px">Go back to
          {{
            editStrategyData.isEdit ? "Past Strategies" : "Publish Strategy"
          }}</el-button>
        <br />
        <el-button v-if="!editStrategyData.isEdit"
          class="btn-theme-borderd left-margin-10 right-margin-10 top-margin-10" size="mini"
          @click="$router.push('/past-strategy-options')" style="width:190px">Track Strategy
        </el-button>
      </div>
    </el-dialog>

    <el-dialog class="strategy-dialog" :visible.sync="strategyNameDialogVisible" :close-on-click-modal="false" center>
      <div class="">
        <h3>Name of Strategy</h3>
        <el-input v-model="strategyName"></el-input>
        <div class="top-margin-25 flex-end">
          <el-button class="btn-theme-gray-borderd" size="mini" style="width: 120px"
            @click="published_notification_dialog_visibility = false">Back</el-button>
          <el-button class="btn-theme-borderd" size="mini" style="width: 120px"
            @click="published_notification_dialog_visibility = false">Next</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="strategy-dialog" :visible.sync="discardChangesPopup" :close-on-click-modal="false"
      :show-close="false" center>
      <div class="">
        <h3>Are you sure you want to discard the selected strategy!</h3>

        <div class="top-margin-25 flex-end">
          <el-button class="btn-theme-gray-borderd" size="mini" style="width: 120px"
            @click="setOldStock()">No</el-button>
          <el-button class="btn-theme-borderd" size="mini" style="width: 120px" @click="clearData()">Yes</el-button>
        </div>
      </div>
    </el-dialog>
    <AccessPublisher />

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>
  </div>
</template>
<script>
var echarts = require("echarts");
import SearchStock from "@/components/SearchStockDerivatives.vue";
import MobileNav from "@/components/MobileNav.vue";
import { EventBus } from "../eventBus";
import axios from "axios";
import CripNotice from "crip-vue-notice";
import { derivativesApiCall } from "../mixins/DerivativesApi";
import moment from "moment";
import { graphData } from "../mixins/LineGraphDataOptions";
import { serverAddr } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import AccessPublisher from "@/components/AccessPublisher.vue";
import ProcessKycComponent from "@/components/NewKycFlow.vue";

export default {
  name: "PublishRecommendationOptions",
  components: {
    SearchStock,
    MobileNav,
    AccessPublisher,
    ProcessKycComponent,
  },
  mixins: [derivativesApiCall, graphData, filterCallBack],
  data() {
    return {
      planSubscriptionStatusDetails: null,
      moment: moment,
      isMarketClose: false,
      nav_title: "Upload Recommendations Options",
      strikeLoading: false,
      tableDialogVisible: false,
      logicDialogVisible: false,
      published_notification_dialog_visibility: false,
      strategyNameDialogVisible: false,
      discardChangesPopup: false,
      is_sock_data_loading: false,
      date: "",
      strategyName: "",
      risk_tag_options: [
        {
          label: "Low Risk",
          value: "Low Risk",
        },
        {
          label: "Moderate Risk",
          value: "Moderate Risk",
        },
        {
          label: "High Risk",
          value: "High Risk",
        },
      ],

      buyTagList: [
        "Bullish Reversal",
        "Uptrend",
        "Breakout",
        "Volatility",
        "Scalping",
        "Bullish",
        "Limited Profit",
        "Technical Based",
        "High Return",
        "Limited Loss",
      ],
      sellTagList: [
        "Bearish Reversal",
        "Down trend",
        "Breakout",
        "Volatility",
        "Scalping",
        "Bearish  ",
        "Limited Profit",
        "Technical Based",
        "High Return",
        "Limited Loss",
      ],
      multiLegTagList: [
        "Bear Put Spread",
        "Bull Call Spread",
        "Potective Collar",
        "Long Strangle",
        "Iron Condor",
        "Iron Butterfly",
        "Hedging",
        "Straddle",
        "Technical Based",
        "Bullish Reversal",
        "Bearish Reversal",
        "Uptrend",
        "Downtrend",
        "High Return",
        "Limited Loss",
        "Limited Profit",
      ],
      selectedTags: [],
      selectedRiskTags: [],
      logicTagList: [],
      directionList: [
        {
          label: "Buy",
          value: "BUY",
        },
        {
          label: "Sell",
          value: "SELL",
        },
      ],

      stockList: [],
      selectedStock: {},
      pickerOptions: {
        disabledDate: this.disabledDueDate,
      },
      strikeData: [],
      strike_data_page_no: 1,
      validateDataList: [],
      selectedLogicBtn: "BULLISH",
      logicDescription: "",
      changedStock: {},
      logicFiles: [],
      fileList: [],
      direction: "",
      order_type: "",
      average_target_potential: 0,
      total_margin: 0,
      total_roi: 0,
      strategyOverviewData: [],
      lineChartInstance: "",
      indiceExpiry: "",
      selectedSpotPrice: null,
      editStrategyData: {
        isEdit: false,
        isFieldsUpdate: false,
        logic_id: null,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("profile")) {
      setTimeout(() => {
        var userProfile = JSON.parse(localStorage.getItem("profile"));

        if (
          userProfile && userProfile.profession == 'Retail Investor'
        ) {
          next({ name: "expertsPastRecommendations" });
        }
      }, 0);
    }
    next();
  },

  watch: {
    getPlanSubscriptionStatus(newValue, oldValue) {
      this.planSubscriptionStatusDetails = newValue.message;

      if (
        this.planSubscriptionStatusDetails &&
        this.planSubscriptionStatusDetails.extra_info.transaction_status ==
        "SUCCESS"
      ) {
        if (this.planSubscriptionStatusDetails.data.plan == "Publisher") {
          localStorage.setItem(
            "publisher_plan_details",
            JSON.stringify(this.planSubscriptionStatusDetails.data)
          );
        } else {
          localStorage.setItem(
            "plan_details",
            JSON.stringify(this.planSubscriptionStatusDetails.data)
          );
        }

        this.$store.commit("commitKycDialog", true);
      }
    },
  },
  mounted() {
    this.checkMarketStatus();

    EventBus.$on("selectedStock", (stock) => {
      if (this.stockList.length > 0) {
        this.discardChangesPopup = true;
        this.changedStock = stock;
      } else {
        this.selectedStock = stock;
        this.indiceExpiry = this.selectedStock.expiry;
        this.getStrikeData();
        this.addRemoveStock("add");
      }
      this.getCurrentPriceOfSelectedStock();
    });

    if (this.$store.state.optionEditStockDetails.data) {
      this.setEditStrategyData(this.$store.state.optionEditStockDetails);
    }
  },
  methods: {

    getCurrentPriceOfSelectedStock() {
      serverAddr
        .get(`/options/get_indices_cmp?title=${this.selectedStock.title}`)
        .then((response) => {
          if (response.data.status) {
            var data = response.data.data;
            this.selectedSpotPrice = data.spot_price;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    checkInputFieldsStatus() {
      setTimeout(() => {
        if (!this.strategyOverviewData.status) {
          new CripNotice({
            title: "Error",
            description: "Please fill all required fields",
            type: "error",
            duration: 3,
          });
        }
      }, 200);
    },
    checkMarketStatus() {
      var format = "hh:mm:ss";

      // real time
      var time = moment();
      var todayDate = moment().format("YYYY-MM-DD");

      var beforeTime = moment("09:15:00", format);
      var afterTime = moment("15:30:00", format);

      if (time.isBetween(beforeTime, afterTime)) {
        serverAddr
          .get("/base/v1/holiday")
          .then((response) => {
            // check for market holiday
            this.isMarketClose =
              response.data.data.includes(todayDate) == true ? true : false;

            this.order_type = this.isMarketClose ? "LIMIT" : "MARKET";
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.isMarketClose = true;
        this.order_type = "LIMIT";
      }
    },
    disabledDueDate(time) {
      // 8.64e7 is epoc one day

      var yesterday = Date.now() - 8.64e7;
      var expiry = moment(this.indiceExpiry).valueOf() + 8.64e7;

      return !moment(time.getTime()).isBetween(yesterday, expiry);
    },

    setMarketPrice() {
      this.stockList.forEach((element, index) => {
        element.entryPremium = element.ltp;
        // element.strikePrice = element.strikePrice
        this.calculateMargin(element, index);
      });
    },
    editStrategyLegs() {
      this.selectedTags = this.editStrategyData.strategy.sub_tags;
      this.selectedRiskTags = this.editStrategyData.strategy.risk_tag;

      this.logicDescription = this.editStrategyData.logic.length
        ? this.editStrategyData.logic[0].discription
        : "";

      // this.editStrategyData.logic[0].mediaArray.forEach((element) => {});
      // this.logicFiles
      this.logicDialogVisible = true;
    },
    setEditStrategyData(strategyData) {
      var strategyObj = {
        data: strategyData.data,
        logic: strategyData.logic,
        strategy: strategyData.strategy,
        id: strategyData.strategy.id,
        isEdit: true,
        isFieldsUpdate: false,
        logic_id: strategyData.logic.length ? strategyData.logic[0].id : "",
      };
      this.editStrategyData = strategyObj;
      this.selectedLogicBtn = this.editStrategyData.strategy.tag;
      this.total_margin = this.editStrategyData.strategy.total_margin[0];

      var selectedStock = {
        expiry: this.editStrategyData.strategy.expiry,
        title: this.editStrategyData.strategy.title,
      };

      this.selectedStock = selectedStock;

      // this.order_type =

      this.getStrikeData();
      // this.addRemoveStock("add");
      EventBus.$emit("selectPreviousStock", this.selectedStock);
      EventBus.$emit("disableSearch", true);
      this.addExistingDetails(this.editStrategyData);
    },
    addExistingDetails(stockData) {
      stockData.data.forEach((element) => {
        var obj = {
          option: element.option,
          strike: element.stock.id,
          lotQuantity: element.quantity,
          direction: element.direction,
          lotSize: element.stock.lot_size,
          legId: element.id,
          entryPremium: element.entry_premium,
          targetPremium: element.target_premium,
          stopLoss: element.stop_loss,
          targetPeriod: element.result_timestamp,
          margin: element.margin,
          isStrategyExist: false,
          order_type: this.order_type,
          roi: 0,
          ltp: element.stock.ltp,
          isLegUpdate: false,
          id: element.id,
          potential: element.target_potential,
          status: element.status,
        };
        this.stockList.push(obj);
      });
      this.calculateStrategyOverview();
    },
    removeFile(index) {
      // this.logicFiles.splice(index, 1);
      this.logicFiles = Array.from(this.logicFiles);
      this.logicFiles.splice(index, 1); // here u remove the file
    },

    initLineGraphComponent() {
      let lineChartComponentContainer = this.$refs["strategy_graph"];
      this.lineChartInstance = echarts.init(
        lineChartComponentContainer,
        null,
        this.initOptions
      );
    },

    clearGraph() {
      this.lineChartInstance.clear();
    },

    reRenderGraph() {
      this.clearGraph();
      this.lineChartInstance.setOption(this.lineGraph);
    },

    calculateStrategyOverview() {
      var newList = [];
      this.stockList.forEach((element, index) => {
        if (
          element.strike &&
          element.direction &&
          element.lotQuantity &&
          element.entryPremium &&
          element.margin &&
          element.targetPremium &&
          element.stopLoss
        ) {
          var stockObj = {
            stock: element.strike,
            direction: element.direction,
            quantity: Number(element.lotQuantity),
            entry_premium: Number(element.entryPremium),
            margin: Number(element.margin) ? Number(element.margin) : 1,
            target_premium: Number(element.targetPremium),
            stop_loss: Number(element.stopLoss),
          };
          newList.push(stockObj);

          // calculateAvragePotential
          var total_potential = this.stockList.reduce(function (sum, current) {
            current.potential = Math.abs(current.potential);
            return sum + current.potential;
          }, 0);

          this.average_target_potential = total_potential / (index + 1);
        }
      });
      if (newList.length) {
        this.calculateStrategyOverviewCallBack(newList);
      }
    },

    calculateStrategyOverviewCallBack(list) {
      this.initLineGraphComponent();
      this.lineChartInstance.showLoading(this.loader_default);

      serverAddr
        .post(`/options/strategy/overview`, list)
        .then((response) => {
          if (response.data.status) {
            this.strategyOverviewData = response.data.data;
            this.strategyOverviewData.status = true;

            var rr_ratio = this.strategyOverviewData.rr_ratio.split(":");
            this.strategyOverviewData.rr_ratioA = Number(rr_ratio[0]);
            this.strategyOverviewData.rr_ratioB = Number(rr_ratio[1]);

            if (this.strategyOverviewData.rr_ratioA < 0) {
              this.strategyOverviewData.rr_ratioA = -this.strategyOverviewData
                .rr_ratioA;
            }
            if (this.strategyOverviewData.rr_ratioB < 0) {
              this.strategyOverviewData.rr_ratioB = -this.strategyOverviewData
                .rr_ratioB;
            }

            this.strategyOverviewData.series.forEach((element) => {
              element.type = "line";
              element.areaStyle = {};
            });

            this.strategyOverviewData.x_axis.type = "category";

            this.seriesMinValue = Math.min(
              ...this.strategyOverviewData.series[0].data
            );
            this.seriesMaxValue = Math.max(
              ...this.strategyOverviewData.series[0].data
            );

            this.lineGraphXaxis = this.strategyOverviewData.x_axis;
            this.lineGraphSeries = this.strategyOverviewData.series;

            this.reRenderGraph();
            this.lineChartInstance.hideLoading(this.loader_default);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    checkStrikePriceIfPresent(strikeId) {
      var selectedStrikeArray = [];
      this.stockList.forEach((element) => {
        selectedStrikeArray.push(element.strike);
      });
      return selectedStrikeArray.includes(strikeId);
    },

    setEntryPremium(strike_id, index) {
      this.stockList[index].margin = 0;
      this.stockList[index].stopLoss = 0;

      this.strikeData.forEach((element) => {
        if (strike_id == element.id) {
          this.stockList[index].lotSize = element.lot_size;
          this.stockList[index].ltp = element.ltp;
          this.stockList[index].timeStamp = element.timeStamp;
          this.stockList[index].entryPremium = element.ltp;
          this.stockList[index].targetPeriod = element.expiry;
          this.stockList[index].ltp = element.ltp;
          this.stockList[index].strikePrice = element.strikePrice;

          if (this.stockList[index].direction == "BUY") {
            this.stockList[index].targetPremium = element.ltp + 2;
            // this.stockList[index].stopLoss = element.ltp - 1;
          } else if (this.stockList[index].direction == "SELL") {
            this.stockList[index].targetPremium = element.ltp - 1;
            // this.stockList[index].stopLoss = element.ltp + 2;
          }

          this.calculateMargin(this.stockList[index], index);
        }
      });
    },

    selectOption(index, item, data) {
      var newObj = this.strikeData.filter((el) => {
        return el.id == item;
      })[0];

      this.stockList[index].option =
        newObj && newObj.label.includes("CE") ? "CALL" : "PUT";

      if (
        data.direction &&
        data.targetPeriod &&
        !this.editStrategyData.isEdit
      ) {
        this.checkStrategyStatus(
          index,
          newObj.id,
          data.direction,
          data.targetPeriod
        );
      }
    },
    getStrikeData() {
      this.getStrikeDataCalBack();
    },
    getLogicAttachments() {
      this.fileList = [];

      let size = 0;
      this.fileList = this.$refs["logic_file"].files;
      // this.fileList = this.attachment;

      for (let i = 0; i < this.fileList.length; i++) {
        size += this.fileList[i].size;
      }

      // check length if already uploaded some files

      if (this.fileList && this.logicFiles.length + this.fileList.length > 4) {
        this.$alert(`Maximum Files Allowed - 4`, "Error!", {
          confirmButtonText: "OK",
        });
        this.fileList = [];
      } else if (size > 1040 * 1024 * 5) {
        this.$alert(
          `Total size is too large. Allowed maximum size is 5 MB`,
          "Error!",
          {
            confirmButtonText: "OK",
          }
        );
        this.fileList = [];
      } else {
        for (let index = 0; index < this.fileList.length; index++) {
          this.logicFiles.push(this.fileList[index]);
        }
      }
    },
    addRemoveStock(action, index, id) {
      if (action == "remove") {
        if (this.editStrategyData.isEdit && id) {
          this.deleteStrategyLeg(id, index);
        } else {
          this.stockList.splice(index, 1);
        }
        this.calculateTotalMargin();
      } else if (action == "add") {
        var obj = {
          option: "",
          strike: null,
          lotQuantity: 1,
          direction: "",
          lotSize: 0,
          entryPremium: null,
          targetPremium: "",
          stopLoss: "",
          targetPeriod: "",
          margin: 0,
          isStrategyExist: false,
          order_type: this.order_type,
          roi: 0,
          ltp: 0,
          timeStamp: "",
          potential: 0,
        };
        this.stockList.push(obj);
      }
    },
    calculateTotalMargin() {
      this.total_margin = this.stockList.reduce(function (sum, current) {
        return sum + current.margin;
      }, 0);

      // this.calculateAvgROI();
      this.calculateStrategyOverview();
    },

    publishReco() {
      var allDataField = true;
      var newList = [];
      this.stockList.forEach((element) => {
        if (
          !element.option.length ||
          !element.lotQuantity ||
          (this.order_type == "limit" && !element.entryPremium) ||
          !element.targetPremium ||
          !element.targetPeriod ||
          !element.stopLoss ||
          !element.strike ||
          !element.direction
        ) {
          allDataField = false;
        } else {
          // check for create new strategy
          if (!this.editStrategyData.isEdit) {
            var stockObj = {
              stock: element.strike,
              direction: element.direction,
              quantity: Number(element.lotQuantity),
              option: element.option,
              entry_premium: Number(element.entryPremium),
              margin: Number(element.margin) ? Number(element.margin) : 1,
              target_premium: Number(element.targetPremium),
              stop_loss: Number(element.stopLoss),
              result_timestamp: moment(element.targetPeriod).format(
                "YYYY-MM-DD"
              ),
              order_type: this.order_type,
            };
            newList.push(stockObj);
          } else {
            // check for which strategy is edited only
            if (element.isEditLeg) {
              var stockObj = {
                id: element.id,
                stock: element.strike,
                direction: element.direction,
                quantity: Number(element.lotQuantity),
                option: element.option,
                entry_premium: Number(element.entryPremium),
                margin: Number(element.margin) ? Number(element.margin) : 1,
                target_premium: Number(element.targetPremium),
                stop_loss: Number(element.stopLoss),
                result_timestamp: moment(element.targetPeriod).format(
                  "YYYY-MM-DD"
                ),
                order_type: this.order_type,
                edit_type: "EDIT",
              };
              newList.push(stockObj);
            }
          }
        }
      });
      if (allDataField == false) {
        this.validateDataList = [];
        new CripNotice({
          title: "Error",
          description: "Please fill all required fields",
          type: "error",
          duration: 3,
        });
      } else {
        if (newList.length == 1) {
          if (newList[0].direction == "BUY") {
            this.logicTagList = this.buyTagList;
          } else if (newList[0].direction == "SELL") {
            this.logicTagList = this.sellTagList;
          }
        } else if (newList.length > 1) {
          this.logicTagList = this.multiLegTagList;
        }

        // pre select data for edit logic
        if (this.editStrategyData.isEdit) {
          this.selectedTags = this.editStrategyData.strategy.sub_tags;
          this.selectedRiskTags = this.editStrategyData.strategy.risk_tag;
          this.logicDescription = this.editStrategyData.logic.length
            ? this.editStrategyData.logic[0].discription
            : "";

          // this.editStrategyData.logic[0].mediaArray.forEach((element) => {});
        }
        this.logicDialogVisible = true;
        this.validateDataList = newList;
      }
    },

    validatePremiumAndStopLoss(index) {
      if (this.stockList[index].direction == "BUY") {
        if (
          this.stockList[index].entryPremium >
          this.stockList[index].targetPremium
        ) {
          this.$alert(
            `Target Premium must be positive integer and greater than Entry Premium`,
            "Error!",
            {
              confirmButtonText: "OK",
            }
          );
          this.stockList[index].targetPremium =
            this.stockList[index].entryPremium + 2;

          if (
            this.stockList[index].entryPremium < this.stockList[index].stopLoss
          ) {
            this.stockList[index].stopLoss =
              this.stockList[index].entryPremium - 1;
          }
        } else if (
          this.stockList[index].entryPremium < this.stockList[index].stopLoss
        ) {
          this.$alert(
            `Stop loss must be positive integer and lower than Entry Premium`,
            "Error!",
            {
              confirmButtonText: "OK",
            }
          );
          this.stockList[index].stopLoss =
            this.stockList[index].entryPremium - 1;
        }
        //  else {
        //   this.addRemoveStock("add");
        // }
      } else if (this.stockList[index].direction == "SELL") {
        if (
          this.stockList[index].entryPremium <
          this.stockList[index].targetPremium
        ) {
          this.$alert(
            `Target Premium must be positive integer and less than Entry Premium`,
            "Error!",
            {
              confirmButtonText: "OK",
            }
          );
          this.stockList[index].targetPremium =
            this.stockList[index].entryPremium - 2;
          if (
            this.stockList[index].entryPremium > this.stockList[index].stopLoss
          ) {
            this.stockList[index].stopLoss =
              this.stockList[index].entryPremium + 2;
          }
        } else if (
          this.stockList[index].entryPremium > this.stockList[index].stopLoss
        ) {
          this.$alert(
            `Stop loss must be positive integer and greater than Entry Premium`,
            "Error!",
            {
              confirmButtonText: "OK",
            }
          );
          this.stockList[index].stopLoss =
            this.stockList[index].entryPremium + 2;
        }
      }
    },
    calculateMargin(element, index) {
      if (this.editStrategyData.isEdit) {
        this.editStrategyData.isFieldsUpdate = true;
        this.stockList[index].isEditLeg = true;
      }

      var obj;
      if (
        element.lotQuantity &&
        element.entryPremium &&
        element.targetPremium
      ) {
        obj = {
          stock: element.strike,
          option: element.option,
          direction: element.direction,
          quantity: Number(element.lotQuantity),
          entry_premium: Number(element.entryPremium),
          target_premium: Number(element.targetPremium),
          stop_loss: Number(element.stopLoss),
          price_type: "MARKET",
        };
        // calculate margin locally
        if (element.direction == "BUY") {
          // Existing ELSE logic for BUY condition
          this.stockList[index].margin =
            Number(obj.quantity) *
            Number(element.lotSize) *
            Number(obj.entry_premium);
        } else {
          // Check if title is NIFTY, BANKNIFTY, FINNIFTY AND direction is SELL
          if (
            ["NIFTY", "BANKNIFTY", "FINNIFTY"].includes(
              this.selectedStock.title
            ) &&
            element.direction === "SELL"
          ) {
            // Existing logic for "SELL" under Indice condition
            var exposure_margin =
              Number(this.selectedSpotPrice) *
              Number(element.lotSize) *
              Number(element.lotQuantity) *
              0.02;

            var span_margin = 100000 * Number(element.lotQuantity);

            this.stockList[index].margin = exposure_margin + span_margin;
          } else {
            // New logic for Options Stacks
            var exposure_margin =
              Number(this.selectedSpotPrice) *
              Number(element.lotSize) *
              Number(element.lotQuantity) *
              0.03;

            var span_margin =
              Number(this.stockList[index].strikePrice) *
              Number(element.lotSize) *
              Number(element.lotQuantity) *
              0.2;

            this.stockList[index].margin = exposure_margin + span_margin;
          }
        }
        var target_price =
          Number(obj.quantity) *
          Number(element.lotSize) *
          Number(obj.target_premium);

        this.stockList[index].potential =
          ((this.stockList[index].margin - target_price) /
            this.stockList[index].margin) *
          100;

        this.calculateStrategyOverview();
      }
      if (
        element.lotQuantity &&
        element.entryPremium &&
        element.targetPremium &&
        element.stopLoss &&
        element.strike &&
        element.option.length &&
        element.direction.length
      ) {
        this.calculateTotalMargin();
        this.validatePremiumAndStopLoss(index);
      }
    },

    clearFields() {
      this.strikeData = [];
      this.selectedStock = {};
      this.validateDataList = [];
      this.stockList = [];
      this.selectedTags = [];
      this.selectedRiskTags = [];
      this.strategyOverviewData = [];
      this.logicFiles = [];
      this.fileList = [];
      this.logicDescription = "";
      this.total_margin = 0;
      this.average_target_potential = 0;
      this.order_type = this.isMarketClose == true ? "LIMIT" : "MARKET";
      this.discardChangesPopup = false;
      this.published_notification_dialog_visibility = false;
      this.clearGraph();
    },

    clearData() {
      this.clearFields();
      // select New Stock
      if (this.changedStock) {
        this.selectedStock = this.changedStock;
        this.getStrikeData();
        this.addRemoveStock("add");
      }
    },

    clearDataForSearchInput() {
      if (this.editStrategyData.isEdit) {
        this.$router.push("/past-strategy-options");
      } else {
        this.clearFields();
        EventBus.$emit("removeSelectedStock", "");
      }
    },

    setOldStock() {
      EventBus.$emit("selectPreviousStock", this.selectedStock);
      this.discardChangesPopup = false;
    },

    sendDataToPublish() {
      var descriptionArray = this.logicDescription.split(" ");
      if (this.selectedTags.length < 3) {
        new CripNotice({
          title: "Error",
          description: "Select at list 3 tags to publish",
          type: "error",
          duration: 3,
        });
      } else if (this.selectedRiskTags.length < 1) {
        new CripNotice({
          title: "Error",
          description: "Risk tag is required to proceed",
          type: "error",
          duration: 3,
        });
      }
      //  else if (descriptionArray.length < 50) {
      //   new CripNotice({
      //     title: "Error",
      //     description: "Logic description required minimum 50 words",
      //     type: "error",
      //     duration: 3,
      //   });
      // }
      else {
        this.is_sock_data_loading = true;
        this.logicDialogVisible = false;

        var publish_data_list = {
          title: this.selectedStock.title,
          tag: this.selectedLogicBtn,
          sub_tags: this.selectedTags,
          risk_tag: this.selectedRiskTags,
          legs: this.validateDataList,
        };
        if (this.editStrategyData.isEdit) {
          this.editStrategyCallBack(
            publish_data_list,
            this.editStrategyData.id,
            this.editStrategyData.logic_id
          );
        } else {
          this.publishFinalData(publish_data_list);
        }
      }
    },
  },
  computed: {
    getPlanSubscriptionStatus() {
      return this.$store.state.planStatus;
    },

    //returns user profile from localstorage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },
  beforeDestroy() {
    this.$store.commit("optionEditStockData", "");
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.publish_recommendation {
  min-height: 70vh;
  background-color: $page-background-color;
  padding: 60px 0 60px 0;

  .publish_recommendation_container {
    // min-height: 20vh;
  }

  .publish-reco-details {
    // height: 600px;
    // overflow: scroll;
  }

  .corner-btn {
    display: flex;
    justify-content: end;
  }

  .search_stock_card {
    // margin-top: 50px;
    border-radius: 10px;
    margin: 10px 5px;
    height: 150px;

    h4 {
      font-weight: 600;
      margin: 0 0 10px;
      font-size: 0.9rem;
    }

    .stock_detail_sec {
      display: flex;
      justify-content: space-between;
      width: 500px;
      align-items: center;

      h4 {
        margin: 0;
        margin-top: 4px;
        font-size: 0.9rem;
      }
    }
  }

  .options-table {
    overflow-x: auto;

    .circle {
      padding: 7px 20px;
      border-radius: 15px;
      margin: 2px;
      background: #d4d4d4;
      color: #fff;
      font-size: 10px;
      position: relative;
      bottom: 1px;
    }

    table {
      width: 100%;
      text-align: center;

      th {
        font-size: 0.7rem;
        color: $label-color;
        font-weight: 600;
      }

      td {
        font-size: 0.6rem;
        padding: 5px;
      }
    }

    .mobile-view {
      display: none;
    }
  }

  .primary-theme-head {
    color: $primary-theme-color;
    font-size: 0.9rem;
    font-weight: 600;
  }

  .chart-tabel {
    margin: 10px 5px;
    border-radius: 10px;
    padding: 7px 0;

    .retail-tabs {
      // padding: 0px 20px;
      border: 1px solid gray;
      border-radius: 20px;
      margin-left: 10px;

      .logic-buttons {
        padding: 5px 20px;
        border-radius: 20px;
        margin: -1px;
        font-weight: 500;
        cursor: pointer;
        font-size: 10px;
      }

      .selectedTab {
        font-weight: 600;
        background-color: #079e3e;
        color: #ffff;
      }
    }

    .stock_detail_sec {
      display: flex;
      align-items: center;

      .special-sec {
        margin: 5px 15px;

        img {
          margin-top: 5px;
          width: 18px;
        }
      }

      h4 {
        margin: 0;
        margin-top: 5px;
        font-size: 0.9rem;
      }
    }

    .roi-card {
      background-color: #f1f1f1;
      font-size: 0.7rem;
      padding: 10px;
      margin: 15px;
      width: 110px;
      text-align: center;
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

      // font-weight: 600;
      p {
        margin: 5px;
      }
    }

    .reset-link {
      font-size: 0.7rem;
      color: $label-color;
      font-weight: 600;
      margin: 10px 20px;
      cursor: pointer;
    }
  }

  .stock_detail_table {
    .table-body {
      h4 {
        color: #000;
        margin-top: 0;
        font-weight: 600;
      }
    }

    .ltp-data-table {
      .value-operation {
        .circle {
          padding: 2px 5px;
          border: 1px solid #d4d4d4;
          border-radius: 12px;
          margin: 5px;
          background: #d4d4d4;
          color: #fff;
          font-size: 10px;
        }

        .oval {
          padding: 2px 10px;
          color: #000;
          background: #b1a9a9;
        }
      }

      .rate {
        font-size: 14px;
        font-weight: 500;
      }

      table {
        border: 1px solid #ddd;
        border-radius: 10px;
      }

      #customers {
        font-family: Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
        margin-top: 20px;
      }

      tr> :nth-child(1) {
        text-align: left;
        padding-left: 0 !important;
      }

      tr> :nth-child(2) {
        text-align: center;
      }

      tr> :nth-child(3) {
        text-align: right;
        padding-right: 0 !important;
      }

      #customers td,
      #customers th {
        // border: 1px solid #ddd;
        padding: 8px;
      }

      #customers tr {
        background-color: #f2f2f2;
        border-bottom: 1px solid #ddd;
      }

      #customers tr:hover {
        background-color: #ddd;
      }

      #customers th {
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: left;
        font-size: 12px;
        background-color: #ffff;
        // color: #000;
      }
    }

    .progress-bar-right {
      .progress-bar {
        height: 6px;
        background: #0ccf80;
        float: right;
        margin-top: 3px;
      }
    }

    .progress-bar-left {
      .progress-bar {
        height: 6px;
        background: #fc7e7e;
        float: left;
        margin-top: 3px;
      }
    }
  }

  .publish-icon {
    width: 170px;
  }

  .el-button {
    margin: 5px;
  }

  @media screen and (max-width: 992px) {
    .search_stock_card {
      height: auto;
      margin: 15px 25px;
    }

    .chart-tabel {
      margin: 15px 25px;
    }
  }

  @media screen and (max-width: 768px) {
    .options-table {
      .desktop-view {
        display: none;
      }

      .mobile-view {
        display: block;
        overflow-x: auto;

        table {
          width: auto;
          min-width: unset;
          margin-left: 130px;

          th {
            text-align: left;
            min-width: 115px;
            position: absolute;
            width: 5em;
            left: 25px;
            top: auto;
            background: #ffffff;
            padding: 20px 0;
            padding-left: 10px;
            z-index: 1;
          }

          td {
            min-width: 150px;
            // text-align: left;
            // min-width: 115px;
            // position: absolute;
            // width: 5em;
            // left: 20px;
            // top: auto;
            // background: #ffffff;
            // padding: 10px 0;
          }
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    .search_stock_card {
      height: auto;
      margin: 5px 0px;

      .el-card__body {
        padding: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.publish_recommendation {
  .el-input.is-disabled .el-input__inner {
    color: #535456;
  }

  .el-input__inner {
    font-size: 10px;
  }

  .risk-tag {
    .el-input__inner {
      font-size: 14px;
      font-weight: 600px;
      //color:red;
    }
  }

  .datePicker {
    .el-input__inner {
      border-radius: 20px;
      font-size: 10px;
      width: 125px;
    }

    .el-date-editor.el-input {
      width: 128px;
    }
  }

  .circular-input {
    .el-input__inner {
      border-radius: 20px;
    }
  }

  .target-premium {
    .el-input-number.is-controls-right .el-input__inner {
      padding-right: 15px;
    }

    .el-input-number.is-controls-right .el-input-number__increase {
      display: none;
    }

    .el-input-number.is-controls-right .el-input-number__increase,
    .el-input-number.is-controls-right .el-input-number__decrease {
      display: none;
    }
  }

  .lotInput {
    .el-input__inner {
      width: 50px;
      padding: 0 15px;
      border-radius: 0 15px 15px 0;
    }

    .lotsize-box {
      color: #424242;
      border: 1px solid #dcdfe6;
      background-color: #dcdfe6;
      padding: 6px;
      font-size: 11px;
      font-weight: 500;
      border-radius: 15px 0px 0px 15px;
      width: 30px;
      cursor: not-allowed;
    }
  }

  .SelectDropdown {
    .el-input--mini .el-input__inner {
      border-radius: 15px;
    }
  }

  .sellDropdown {
    .el-input--mini .el-input__inner {
      border-radius: 15px;
      color: red;
      border: 1px solid red;
    }
  }

  .buyDropdown {
    .el-input--mini .el-input__inner {
      border-radius: 15px;
      color: green;
      border: 1px solid green;
    }
  }

  .SearchStock .search-stock-container {
    margin-left: 0;
    margin-bottom: 12px;
  }

  .chart-tabel,
  .search_stock_card {
    .el-card__body {
      // padding: 30px;
    }
  }
}

.stock_detail_table {
  .SearchStock .search-stock-container {
    width: 100%;
  }

  .el-dialog__body {
    padding: 30px 50px;
  }

  .el-dialog {
    width: 700px;
  }

  .el-dialog__header {
    padding: 0px;
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}

.logic-dialog {
  .el-tag.el-tag--info {
    background-color: #e72726;
    border-color: #e72726;
    color: #ffffff;
    font-weight: 600;
    border-radius: 20px;
  }

  .el-tag.el-tag--info .el-tag__close {
    color: #000000;
  }

  .el-select .el-tag__close.el-icon-close {
    background-color: #ffffff;
  }

  .el-select-dropdown {
    // .ul {
    height: 120px !important;
    // }
  }

  .upload-profile {
    color: #2d2e8d;

    i {
      font-size: 1.5rem;
      margin-right: 5px;
    }
  }

  h3 {
    color: #252525;
  }

  textarea {
    width: 98%;
    border-radius: 10px;
    padding: 10px;
  }

  .el-dialog {
    border-radius: 15px;
    width: 700px;
  }

  .el-dialog__header {
    padding: 0px;
  }

  .el-dialog--center .el-dialog__body {
    padding: 25px 60px 30px;
    word-break: normal !important;
  }
}

.published-notification-dialog {
  .el-dialog {
    width: 450px;
    border-radius: 10px;
  }

  .el-dialog__header {
    padding: 0px;
  }
}

.strategy-dialog {
  word-break: normal;

  .el-dialog {
    width: 450px;
    border-radius: 10px;
  }

  .el-dialog__body {
    word-break: normal !important;
  }

  .el-input__inner {
    border-radius: 20px;
  }

  .el-dialog__header {
    padding: 0px;
  }
}

@media screen and (max-width: 880px) {
  .logic-dialog .el-dialog .ellipsis {
    max-width: 220px;
  }
}

@media screen and (max-width: 768px) {
  .stock_detail_table .SearchStock .search-stock-container {
    max-width: 100% !important;
  }

  .stock_detail_table .el-dialog {
    width: 90%;
  }

  .logic-dialog .el-dialog {
    width: 90%;
  }
}

@media screen and (max-width: 550px) {

  .strategy-dialog,
  .published-notification-dialog {
    .el-dialog {
      width: 90%;
    }
  }

  .logic-dialog .el-dialog--center .el-dialog__body {
    padding: 25px;
  }

  .logic-dialog textarea {
    width: 90%;
  }

  .search_stock_card {
    .el-card__body {
      padding: 15px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.publish_recommendation {

  // min-height: 100vh;
  // background-color: $page-background-color;
  // padding: 60px 0 0 0;
  .strategy-graph-section {
    width: 99%;
    margin: 0 auto;
    // background-color: #ffff;

    .graph-label-main-section {
      position: absolute;
      display: flex;
      justify-content: space-between;
      width: 50%;

      .graph-head {
        position: relative;
        top: 20px;
        text-align: center;
        font-size: 0.75rem;
        font-weight: 600;
        color: #2d2e8d;
      }

      .info-label {
        position: relative;
        left: -24px;
        top: 10px;
        background-color: #ffff;
        z-index: 1;
        width: 100px;
        height: 50px;

        .pl-tags {
          justify-content: end;
          font-size: 0.75rem;
          font-weight: 600;
          color: #2d2e8d;
          margin-bottom: 5px;
        }

        .graph-desc {
          width: 18px;
          height: 11px;
          margin-left: 7px;
          border-radius: 4px;
        }

        .graph-desc-color-red {
          background-color: #f0b6b6;
          border: 1px solid #f0b6b6;
        }

        .graph-desc-color-green {
          background-color: #a0eda0;
          border: 1px solid #a0eda0;
        }
      }
    }
  }

  .chart-tabel {
    margin: 10px 5px;
    border-radius: 10px;

    .stock_detail_sec {
      display: flex;
      align-items: center;

      .special-sec {
        margin: 8px;

        .input-label {
          font-size: 1rem !important;
          color: #2d2e8d;
          margin-bottom: 20px;
          font-weight: 600;
        }

        img {
          margin-top: 5px;
          width: 18px;
        }
      }

      h3 {
        margin: 0;
        margin-top: 10px;
        font-size: 1.1rem;
      }
    }

    .roi-card {
      background-color: #e2e2e2;
      font-size: 0.7rem;
      padding: 10px;
      margin: 0 15px;
      width: 110px;
      text-align: center;
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

      // font-weight: 600;
      p {
        margin: 5px;
      }
    }
  }

  .details-chart {
    padding: 10px 0 20px;

    .input-label {
      font-weight: 600;
      font-size: 0.9rem;
      margin: 8px;
    }

    .details-number {
      color: #2d2e8d;
    }
  }

  @media screen and (max-width: 1200px) {
    .strategy-graph-section .graph-label-main-section {
      width: 100%;
    }
  }
}
</style>
